import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { LabelForm,LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
// import { formatearNumeroEntero } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
class FormInven13 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            bodegas: [],
            bodega_sel: undefined,
            tomasInventario: [],
            toma_seleccionada: null,
            incluyeDiferenciaEnCero:'S',
            fechas:[],
            usuarios:[],
            usuario_seleccionado:null,
            fecha_seleccionada:null,
            diferenciaFisicaPorBodega:false,
            resumenItems:false,
            resumenItemsArray:[],
            tipo_reporte_seleccionado:'D',//EXISTEN LOS SIGUIENTES TIPO DE REPORTE, 'D'->Diferencias de Inventario, 'T'->Toma Fisica.
            columnDefs: [ 
                {   header: "Bodega",
                    field: "Bodega",
                    width: 300,
                    type: "string"
                },
                {   header: "Numero de Artículos",
                    field: "Cantidad_Articulo",
                    width: 350,
                    type: "num_entero"
                }            
            ],
        };
       
        this.gridOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: true,
            rowSelection: "single",
            suppressScrollOnNewData: true,
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
          onRowDoubleClicked: event => {
          },
         
        };
        this.limpiar = this.limpiar.bind(this);        
        this.generarReporteDiferenciaInventario = this.generarReporteDiferenciaInventario.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.cargarTomasInventarioNueva = this.cargarTomasInventarioNueva.bind(this);
        this.cargarFechasCierre = this.cargarFechasCierre.bind(this);
        this.cargarResumentItems= this.cargarResumentItems.bind(this);
        this.onGridReady = this.onGridReady.bind(this);   
        this.generarReporteItemsToma=this.generarReporteItemsToma.bind(this);
        this.cargarBodegasTomaInventario= this.cargarBodegasTomaInventario.bind(this);
    }
    
    generarReporteItemsToma(tipo){
        let urlReportWithParams='';
        if (this.state.toma_seleccionada === null){
            alert("Seleccione una Toma De Inventario para continuar...")
            return;
        }else{
            urlReportWithParams += '&param1='+this.state.toma_seleccionada;
        }
        if(tipo==='PDF'){
            urlReportWithParams =`&rpt=120`.concat(urlReportWithParams);
            visualizarReporteEnPdf(urlReportWithParams);
        }
    }
    handleInputChange(event) {
        const target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        if(target.type==='radio' && name==='tipo_reporte_seleccionado'){
            this.limpiar();
        }
        this.setState({
          [name]: value
        });
    }
    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
      }
    cargarResumentItems(){
        if (this.state.toma_seleccionada === null){
            alert("Seleccione una Toma De Inventario para continuar...")
            return;
        }
      
        global_axios(
            { method: 'GET',
              url: 'tomainventario/cargar_resumen_items_toma_inventario/?tomaInventario='+this.state.toma_seleccionada,
            }
        )
        .then((response)=>{
                this.setState({
                    resumenItemsArray:response.data.items
                })
            })
        .catch((err)=>{
            alert('No se pudo obtener el resumen...');
        });
    }
    cargarTomasInventarioNueva(){
        global_axios(
          { method: 'GET',
            url: 'tomainventario/cargar_tomas_inventario/',
          }
        )
        .then((response)=>{
              let  tomas = response.data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})` }));
              this.setState({tomasInventario:tomas})
            })
          .catch((err)=>{
            alert('No se pudo obtener Tomas de Inventario...');
          });
    }
    cargarBodegasTomaInventario(){
        let query = "?tomaInventarioId="+this.state.toma_seleccionada;   
        global_axios(
          { method: 'GET',
            url: 'tomainventario/cargar_bodegas_toma_inventario/'+ query,
          }
        )
        .then((response)=>{
              let  bodegas = response.data.bodegasFinales.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()} (${item.Codigo.toString().toUpperCase()})`}));
              this.setState({bodegas:bodegas})
            })
          .catch((err)=>{
            alert('No se pudo obtener las bodegas de la Toma de Inventario...');
          });
    }
    cargarFechasCierre(value){
        this.setState({toma_seleccionada: value!==null?value.value:null, fecha_seleccionada:null, fechas:[]},()=>{
            let query = "?&tomaInventario="+ this.state.toma_seleccionada;   
            global_axios(
                { method: 'GET',
                  url: 'tomainventario/cargar_fechas_cierre_toma'+query,
                }
              )
            .then((response)=>{
                    let  fechas =response.data.fechas.map(item => ({value: item.Fecha.toString().toUpperCase(), label: item.Fecha.toString().toUpperCase()}));
                    this.setState({fechas:fechas},()=>{
                        this.cargarUsuariosToma();
                    })
                  })
            .catch((err)=>{
                  alert('No se pudo obtener Fechas...');
            });
        });
    }
    cargarUsuariosToma(){    
        let query = "?&tomaInventario="+ this.state.toma_seleccionada;   
        global_axios(
            { method: 'GET',
                url: 'tomainventario/cargar_usuarios_toma'+query,
            }
        )
        .then((response)=>{
                let  usuarios =response.data.usuarios.map(item => ({value: item.Usuario.toString().toUpperCase(), label: item.Usuario.toString().toUpperCase()}));
                usuarios.unshift({
                    value: 'todos',
                    label:'TODOS'
                })
                this.setState({usuarios:usuarios},()=>{
                    this.cargarBodegasTomaInventario()
                })
                })
        .catch((err)=>{
                alert('No se pudo obtener Usuarios...');
        });
    }
    componentDidMount(){
        Promise.all([
            this.cargarTomasInventarioNueva(), 
            this.props.generar_LogAuditoriaIngresoForm('0213')//Willy20191206 corrección formulario
         ])
       
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0213');//Willy20191206
    }
    generarReporteDiferenciaInventario(tipoRpt){        
        try {
            let urlReportWithParams='';
            let localidad='01'
            if(this.state.tipo_reporte_seleccionado ==='D')//TIPO DE REPORTE DE DIFERENCIAS
            {
                
                if (this.state.bodega_sel != null){
                    urlReportWithParams += `&param1=${this.state.bodega_sel}`;
                }else{
                    alert("Seleccione una Bodega para continuar...")
                    return;
                }
                if (this.state.toma_seleccionada!= null){
                    urlReportWithParams += '&param2='+this.state.toma_seleccionada;
                }else{
                    alert("Seleccione una Toma De Inventario para continuar...")
                    return;
                }
                if(this.state.fecha_seleccionada !== null){
                    urlReportWithParams += '&param3='+this.state.fecha_seleccionada;
                }else{
                    alert("Seleccione una Fecha de Cierre para continuar...")
                }
                urlReportWithParams += `&param4=${this.state.incluyeDiferenciaEnCero}`;
                urlReportWithParams += '&param5='+localidad;
                if(tipoRpt==='PDF'){
                    urlReportWithParams = `&rpt=111`.concat(urlReportWithParams);
                    visualizarReporteEnPdf(urlReportWithParams);
                }else{
                    urlReportWithParams = `&rpt=112`.concat(urlReportWithParams);
                    generarReporteEnExcel(urlReportWithParams);
                }
            }else if(this.state.tipo_reporte_seleccionado==='T'){//TIPO DE REPORTE DE TOMA FISICA
                if (this.state.toma_seleccionada!= null){
                    urlReportWithParams += '&param1='+this.state.toma_seleccionada;
                }else{
                    alert("Seleccione una Toma De Inventario para continuar...")
                    return;
                }
                if(this.state.fecha_seleccionada !== null){
                    urlReportWithParams += '&param2='+this.state.fecha_seleccionada;
                }else{
                    alert("Seleccione una Fecha de Cierre para continuar...")
                    return;
                }
                if(this.state.usuario_seleccionado!== null){
                    urlReportWithParams += '&param3='+this.state.usuario_seleccionado;
                }else{
                    alert("Seleccione un Usuario para continuar...")
                    return;
                }
                    urlReportWithParams += '&param4='+localidad;
                if(tipoRpt==='PDF'){
                    urlReportWithParams = `&rpt=113`.concat(urlReportWithParams);
                    visualizarReporteEnPdf(urlReportWithParams);
                }

            }
            else if(this.state.tipo_reporte_seleccionado==='C'){ //CONSOLIDADO
                if (this.state.toma_seleccionada!= null){
                    urlReportWithParams += '&param1='+this.state.toma_seleccionada;
                }else{
                    alert("Seleccione una Toma De Inventario para continuar...")
                    return;
                }
                urlReportWithParams += `&param2=${this.state.incluyeDiferenciaEnCero}`;
                if (this.state.bodega_sel != null){
                    urlReportWithParams += `&param3=${this.state.bodega_sel}`;
                }else{
                    alert("Seleccione una Bodega para continuar...")
                    return;
                }
                if(this.state.diferenciaFisicaPorBodega){
                    urlReportWithParams += `&param4=S`;
                    urlReportWithParams += '&param5='+ localidad;
                }else{
                    urlReportWithParams += '&param4='+localidad;
                }
                if(tipoRpt==='PDF'){
                    urlReportWithParams =(!this.state.diferenciaFisicaPorBodega)?`&rpt=114`.concat(urlReportWithParams):`&rpt=118`.concat(urlReportWithParams);
                    visualizarReporteEnPdf(urlReportWithParams);
                }else{
                 
                    urlReportWithParams = (!this.state.diferenciaFisicaPorBodega)?`&rpt=115`.concat(urlReportWithParams):`&rpt=119`.concat(urlReportWithParams);;
                    generarReporteEnExcel(urlReportWithParams);
                }
            }
            else if(this.state.tipo_reporte_seleccionado==='G'){
                if (this.state.toma_seleccionada!= null){
                    urlReportWithParams += '&param1='+this.state.toma_seleccionada;
                }else{
                    alert("Seleccione una Toma De Inventario para continuar...")
                    return;
                }
                urlReportWithParams += `&param2=${this.state.incluyeDiferenciaEnCero}`;
                urlReportWithParams += '&param3='+localidad;
                if(tipoRpt==='PDF'){
                    urlReportWithParams =`&rpt=116`.concat(urlReportWithParams);
                    visualizarReporteEnPdf(urlReportWithParams);
                }else{
                 
                    urlReportWithParams = `&rpt=117`.concat(urlReportWithParams);
                    generarReporteEnExcel(urlReportWithParams);
                }
            }
            else if(this.state.tipo_reporte_seleccionado==='U'){//CONSOLIDADO POR USUARIO
                if (this.state.bodega_sel != null){
                    urlReportWithParams += `&param1=${this.state.bodega_sel}`;
                }else{
                    alert("Seleccione una Bodega para continuar...")
                    return;
                }
                if (this.state.toma_seleccionada!= null){
                    urlReportWithParams += '&param2='+this.state.toma_seleccionada;
                }else{
                    alert("Seleccione una Toma De Inventario para continuar...")
                    return;
                }
                urlReportWithParams += `&param3=${this.state.incluyeDiferenciaEnCero}`;
                urlReportWithParams += '&param4='+localidad;
                if(this.state.usuario_seleccionado!== null){
                    urlReportWithParams += '&param5='+this.state.usuario_seleccionado;
                }else{
                    alert("Seleccione un Usuario para continuar...")
                    return;
                }

                if(tipoRpt==='PDF'){
                    urlReportWithParams =`&rpt=121`.concat(urlReportWithParams);
                    visualizarReporteEnPdf(urlReportWithParams);
                }
            }
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        this.setState({bodega_sel:null,
       toma_seleccionada:null,
        fecha_cierre:null,
        fechas:[],
        incluyeDiferenciaEnCero:'S',
        itemTomado:false,
        usuarios:[],
        usuario_seleccionado:null,
        resumenItemsArray:[],
        diferenciaFisicaPorBodega:false
        })
    }

    render(){
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Diferencias Entre Inventario Fisico Y Contable</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={15}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Reporte:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-12'>					
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='D' checked={this.state.tipo_reporte_seleccionado==='D'} onChange={this.handleInputChange} />
                                Diferencias entre inventario fisico y contable
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='T' checked={this.state.tipo_reporte_seleccionado==='T'} onChange={this.handleInputChange} />
                                Toma Fisica
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='C' checked={this.state.tipo_reporte_seleccionado==='C'} onChange={this.handleInputChange} />
                                Reporte Consolidado Por Bodega
                            </LabelForm> 
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='G' checked={this.state.tipo_reporte_seleccionado==='G'} onChange={this.handleInputChange} />
                                Reporte Consolidado General
                            </LabelForm> 
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipo_reporte_seleccionado' value='U' checked={this.state.tipo_reporte_seleccionado==='U'} onChange={this.handleInputChange} />
                                Reporte Consolidado Por Usuario
                            </LabelForm> 
                        </ContainerCol>
                    </Row>
                   <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Toma Inventario:</LabelForm>
                            <ReactSelect options={ this.state.tomasInventario } value={this.state.toma_seleccionada} func_onChange={(value)=>{this.cargarFechasCierre(value)}}/>
                        </ContainerCol>
                       {
                        (this.state.tipo_reporte_seleccionado==='D' || this.state.tipo_reporte_seleccionado==='C' || this.state.tipo_reporte_seleccionado==='U')
                        ?
                        <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                           <LabelForm>Bodega:</LabelForm>
                           <ReactSelect options={ this.state.bodegas } value={this.state.bodega_sel} func_onChange={(value)=>{this.setState({bodega_sel: value!==null?value.value:null})}}/>
                       </ContainerCol>
                       :null
                       } 
                        {
                            (this.state.tipo_reporte_seleccionado==='D' || this.state.tipo_reporte_seleccionado==='T')
                            ?
                            <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                                <LabelForm>Fecha:</LabelForm>
                                <ReactSelect options={ this.state.fechas } value={this.state.fecha_seleccionada} func_onChange={(value)=>{this.setState({fecha_seleccionada: value!==null?value.value:null})}}/>
                            </ContainerCol>
                            :
                            null
                        }
                        {
                            (this.state.tipo_reporte_seleccionado==='T' || this.state.tipo_reporte_seleccionado==='U')
                            ?
                            <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                                <LabelForm>Usuarios:</LabelForm>
                                <ReactSelect options={ this.state.usuarios } value={this.state.usuario_seleccionado} func_onChange={(value)=>{this.setState({usuario_seleccionado: value!==null? value.value:null})}}/>
                            </ContainerCol> 
                            :
                            null
                        }
                       
                       {
                           (this.state.tipo_reporte_seleccionado==='D'|| this.state.tipo_reporte_seleccionado==='C' || this.state.tipo_reporte_seleccionado==='G' || this.state.tipo_reporte_seleccionado==='U')
                           ?
                            // <ContainerCol className='col-sm-6' margen_arriba='30' margen_abajo='4'>
                            //     <LabelForm><input type='checkbox' name='incluyeDiferenciaEnCero' checked={this.state.incluyeDiferenciaEnCero} 
                            //     onChange={this.handleInputChange}/> Incluye Diferencias en Cero</LabelForm>
                            // </ContainerCol> 
                            <ContainerCol className='col-sm-8' margen_arriba='30' margen_abajo='4'>
                                <LabelForm>Opciones:</LabelForm>                                
                                <div>
                                    <LabelRadio className='radio-inline'><input type='radio' value='S' name='incluyeDiferenciaEnCero' checked={this.state.incluyeDiferenciaEnCero==='S'}
                                        onChange={this.handleInputChange}/> Con Ceros
                                    </LabelRadio>
                                    <LabelRadio className='radio-inline'><input type='radio' value='N' name='incluyeDiferenciaEnCero' checked={this.state.incluyeDiferenciaEnCero==='N'}
                                        onChange={this.handleInputChange}/> Sin Ceros
                                    </LabelRadio>
                                    {
                                        (this.state.tipo_reporte_seleccionado==='G')
                                        ?
                                        <LabelRadio className='radio-inline'><input type='radio' value='M' name='incluyeDiferenciaEnCero' checked={this.state.incluyeDiferenciaEnCero==='M'}
                                            onChange={this.handleInputChange}/> Sobrantes
                                        </LabelRadio>
                                        :
                                        null
                                    }
                                    {
                                        (this.state.tipo_reporte_seleccionado==='G')
                                        ?
                                        <LabelRadio className='radio-inline'><input type='radio' value='F' name='incluyeDiferenciaEnCero' checked={this.state.incluyeDiferenciaEnCero==='F'}
                                            onChange={this.handleInputChange}/> Faltantes
                                        </LabelRadio>
                                        :
                                        null
                                    }
                                </div>
                            </ContainerCol>

                            :
                            null
                       }
                       {
                           ( this.state.tipo_reporte_seleccionado==='C')
                           ?
                            <ContainerCol className='col-sm-6' margen_arriba='30' margen_abajo='4'>
                                <LabelForm><input type='checkbox' name='diferenciaFisicaPorBodega' checked={this.state.diferenciaFisicaPorBodega} 
                                onChange={this.handleInputChange}/> Diferencia Fisica Consolidado Por Bodega</LabelForm>
                            </ContainerCol> 
        
                            :
                            null
                       }
                       {
                           ( this.state.tipo_reporte_seleccionado==='T')
                           ?
                            <div>
                                <ContainerCol className='col-sm-3' margen_arriba='30' margen_abajo='4'>
                                 <button type='button' className='btn btn-link btn-xs'  onClick={this.cargarResumentItems}><i className="fa fa-file-o" aria-hidden="true"/> Visualizar Resumen Items</button>  
                                </ContainerCol>
                                <ContainerCol className='col-sm-3' margen_arriba='30' margen_abajo='4'>
                                 <button type='button' className='btn btn-info btn-sm' onClick={()=>{this.generarReporteItemsToma('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir PDF</button>
                                </ContainerCol>
                            </div>
                           :
                            null
                       }    
                       {
                           ( this.state.tipo_reporte_seleccionado==='T' && this.state.resumenItemsArray.length>0)
                           ?
                            <div>
                                <ContainerCol className='col-xs-12 col-sm-12' align="center">
                                <h5><strong>Resumen Items</strong></h5>
                                </ContainerCol>
                                <ContainerCol className='col-xs-12 col-sm-12'>
                                <AgGridRender altura='100px' data={this.state.resumenItemsArray} columnas={this.state.columnDefs}
                                    gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                                </ContainerCol> 


                            </div>
                           :
                            null
                       } 
                    </Row>
                   
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={()=>{this.generarReporteDiferenciaInventario('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>
                                <button disabled={this.state.tipo_reporte_seleccionado==='T' || this.state.tipo_reporte_seleccionado==='U'} type='button' className='btn btn-success btn-sm' onClick={()=>{this.generarReporteDiferenciaInventario('EXCEL')}}><i className="fa fa-file-excel-o fa-lg" aria-hidden="true"/> Generar Excel</button>
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormInven13);